import { Component, OnInit } from '@angular/core';

import { Projects } from '@usimweb/core/models';

import * as fromRoot from '@usimweb/state/router-store';
import * as fromStore from '@usimweb/state/store';
import { Store } from '@ngrx/store';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Disclaimer } from '@usimweb/ui/dialogs';

@Component({
    selector: 'usimweb-new-project',
    templateUrl: './new-project.component.html',
    styleUrls: ['./new-project.component.scss'],
    standalone: false
})
export class NewProjectComponent implements OnInit {
  public progress: boolean = false;

  constructor(
    private store: Store<fromStore.DashboardState>,
    private snackBar: MatSnackBar,
    private disclaimer: Disclaimer
  ) {}

  ngOnInit(): void {
    this.disclaimer.create();
  }

  back() {
    this.store.dispatch(new fromRoot.Go({ path: ['/app/projects'] }));
  }

  public create(project: Projects) {
    if (project.name) {
      this.progress = true;
      this.snackBar.open('Creating project...', 'OK', { duration: 2000 });
      this.store.dispatch(new fromStore.CreateProjects(project));
      return;
    }

    this.snackBar.open('Please add a project name...', 'OK', { duration: 5000 });
  }
}
